import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import hshape from "../assets/img/hshape.svg"
import CatFeaturedCard from "../components/Featured/CatFeaturedCard";
const AllCourse = () => {
  return (
    <>
       <BreadCrumb />
       <section className="section-space">
            <div className="container-xl">
            <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">Courses</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                    </div>
                </div>
                
                    
                       <CatFeaturedCard />
                   
                    
              
                <div className="text-center">
                    <a href="#" className="btn btn-white mr-top">Load More</a>
                </div>
            </div>
        </section>
    </>
  );
};

export default AllCourse